import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  ScholarshipManagementDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  CountryDto,
  ScholarshipPaymentDto,
  BankDto,
} from '@cradua/data';
import { ScholarshipInfoService } from '../../services/scholarshipinfo.service';
import Swal from 'sweetalert2';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'libs/shared/src/lib/components/modal/modal.component';

@Component({
  selector: 'mrsoftapps-scholarship-management-list',
  templateUrl: './scholarship-management-list.component.html',
  styleUrls: ['./scholarship-management-list.component.scss'],
})
export class ScholarshipManagementListComponent implements OnInit {
  @Input() countries: CountryDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() scholarshipTypes: ScholarshipTypeDto[];
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  @Input() courseOfStudies: CourseOfStudyDto[];
  @Input() scholarshipSessions: ScholarshipSessionDto[];
  @Input() scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  @Input() genders: EpimsGenderDto[];
  @Input() communities: CommunityDto[];
  @Input() searchScholarshipManagement: ScholarshipManagementDto[];
  @Input() scholarshipManagements: ScholarshipManagementDto[];
  @Input() scholarshipPayments: ScholarshipPaymentDto[];
  @Input() banks: BankDto[];
  @Output() changeEmit = new EventEmitter<any>();
  @Output() searchEmit = new EventEmitter<any>();
  @Output() emitEvent = new EventEmitter<any>();
  @Output() dispatchDetails = new EventEmitter<any>();
  @Output() dispatchEdit = new EventEmitter<any>();
  @Output() dispatchView = new EventEmitter<any>();
  @Output() getPaymentEmit = new EventEmitter<any>();
  @Output() dispatchDelete = new EventEmitter<any>();
  constructor(
    private scholarshipInfService: ScholarshipInfoService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {}

  search(value) {
    this.searchEmit.emit(value);
  }

  OnChange(value) {
    if (value.checked) {
      this.searchEmit.emit('.');
    } else {
      this.searchEmit.emit('');
    }
    console.log('this is the val ', value.checked);
  }

  getCourseOfStudy(value) {
    return this.scholarshipInfService.courseOfStudyName(
      this.courseOfStudies,
      value
    );
  }

  getDuration(value) {
    return this.scholarshipInfService.scholarshipAwardDurationName(
      this.scholarshipAwardDurations,
      value
    );
  }

  getState(value) {
    return this.scholarshipInfService.stateName(this.states, value);
  }

  uploadEvent() {
    this.emitEvent.emit('upload');
  }

  createEvent() {
    this.emitEvent.emit('create');
  }

  onViewDetails(value) {
    this.dispatchDetails.emit(value);
  }

  onEdit(value) {
    this.dispatchEdit.emit(value);
  }

  onView(value) {
    this.dispatchView.emit(value);
  }

  onDispatchDelete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.dispatchDelete.emit(id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }
}
